module.exports = __webpack_public_path__ + "static/media/montgomerycc.1e7e8935.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/montgomerycc.png
// module id = 49
// module chunks = 0